module.exports = __webpack_public_path__ + "img/dark-settings-to-chart.71d9154e.svg";